module.exports = __webpack_public_path__ + "img/btn-submit-bm.5cbbeb08.png";